// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestion {
  cursor: pointer;
  border-right: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid black;
}

.suggestion:hover {
  background-color: chartreuse;
}`, "",{"version":3,"sources":["webpack://./src/styles/autocomplete.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".suggestion {\n  cursor: pointer;\n  border-right: 1px solid black;\n  border-left: 1px solid black;\n  border-bottom: 1px solid black;\n}\n\n.suggestion:hover {\n  background-color: chartreuse;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
